import { appConfig } from '../../configs/app-config';
import CycleV2 from './CycleV2';
import Cycle from './Cycle';
import { API_VERSION } from '../../constants/api-constants';

export const CycleTableWrapper = appConfig.apiVersion === API_VERSION.V2 ? CycleV2 : Cycle;
